/* istanbul ignore file */
export { default } from './LoadingSpinner';
